import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import firebase from 'firebase';

const ProviderName = () => {
  const name = firebase.auth().currentUser.displayName;
  return <span> Welcome {name}</span>;
};

export const Dashboard = () => (
  <Card>
    <CardHeader title={<ProviderName />} />
    <CardContent>
      <div>Bienvenu dans l'espace Admin de l'application Apolhygie !</div>
      <br />
      <div>Ici vous pourrez :</div>
      <div>- Assigner des administrateurs à l'espace, </div>
      <div>- Créer, éditer, gérer des missions,</div>
      <div>- Editer et assigner les différentes sociétés aux utilisateurs</div>
    </CardContent>
  </Card>
);



// WEBPACK FOOTER //
// ./src/components/Dashboard.js